module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card messages",
    attrs: {
      "id": "mijnberichten"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "href": "#berichten",
      "aria-controls": "berichten",
      "data-toggle": "collapse",
      "data-target": "#berichten"
    }
  }, [_vm._v("Mijn berichten "), (_vm.unread > 0) ? _c('span', {
    staticClass: "newmessages"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e(), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "berichten"
    }
  }, [_c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.showInbox
    },
    on: {
      "click": _vm.showInboxfunc
    }
  }, [_c('span', [_vm._v("o")]), _vm._v("Inbox\n                        ("), _c('span', [_vm._v(_vm._s(_vm.unread))]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.showOutbox
    },
    on: {
      "click": _vm.updateSent
    }
  }, [_c('span', [_vm._v("J")]), _vm._v("Verzonden")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.showArchived
    },
    on: {
      "click": _vm.showArchivefunc
    }
  }, [_c('span', [_vm._v("a")]), _vm._v("Archief\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), (_vm.replyIframeLoaded != true) ? _c('loader-component') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "error"
    }
  }), _vm._v(" "), (_vm.totalPages === 0) ? _c('div', {
    staticClass: "nomessages"
  }, [(_vm.showInbox === true) ? _c('div', [_vm._v("Er zijn geen berichten in uw\n                            Inbox gevonden.\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.showOutbox === true) ? _c('div', [_vm._v("Er zijn geen verzonden\n                            berichten gevonden.\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.showArchived === true) ? _c('div', [_vm._v("Er zijn geen berichten in\n                            uw archief gevonden.\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.pages[_vm.currentPage]), function(bericht, index) {
    return _c('li', {
      key: index
    }, [_c('bericht-component', {
      attrs: {
        "bericht": bericht,
        "index": index,
        "ctx": _vm.ctx,
        "csrftokenvalue": _vm.csrftokenvalue
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.totalPages > 1) ? _c('nav', {
    staticClass: "paging"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage > 0) ? _c('button', {
    staticClass: "previous btn btn-secondary",
    attrs: {
      "data-href": "#mijnberichten",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage -= 1
      }
    }
  }, [_vm._v("Vorige\n                                ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.totalPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      staticClass: "page-item"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      class: {
        active: pageNumber === _vm.currentPage + 1
      },
      attrs: {
        "data-href": "#mijnberichten",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentPage = pageNumber - 1
        }
      }
    }, [_vm._v(_vm._s(pageNumber) + "\n                                ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage < _vm.totalPages - 1) ? _c('button', {
    staticClass: "next btn btn-secondary",
    attrs: {
      "data-href": "#mijnberichten",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage += 1
      }
    }
  }, [_vm._v("Volgende\n                                ")]) : _vm._e()])], 2)]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "newmessages loader"
  }, [_c('div', {
    staticClass: "loaderframe"
  }, [_c('div', {
    staticClass: "preloader loading"
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553de69d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/berichten/berichten.vue
// module id = 118
// module chunks = 0